import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const heroSlides = [
  {
    bg: 'https://public.readdy.ai/ai/img_res/c1cbdd19bade136b41315706e5c0b784.jpg',
    title: 'Cold Drinks',
    subtitle: 'Delivered Fast',
    tag: 'Georgetown\'s #1 Beverage Delivery',
  },
  {
    bg: 'https://readdy.ai/api/search-image?query=premium%20rum%20spirits%20bottles%20bar%20setup%20Caribbean%20amber%20golden%20luxury%20dark%20background%20moody%20lighting%20elegant%20Guyana%20El%20Dorado&width=1600&height=900&seq=hero2&orientation=landscape',
    title: 'Premium Spirits',
    subtitle: 'At Your Door',
    tag: 'Local & Imported Selections',
  },
  {
    bg: 'https://readdy.ai/api/search-image?query=beer%20party%20celebration%20friends%20tropical%20Caribbean%20outdoor%20Georgetown%20cold%20drinks%20ice%20cooler%20vibrant%20colorful%20festive%20beverages&width=1600&height=900&seq=hero3&orientation=landscape',
    title: 'Party Supplies',
    subtitle: 'In 30 Minutes',
    tag: 'Free delivery over $4,500 GYD',
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setCurrent((c) => (c + 1) % heroSlides.length), 5000);
    return () => clearInterval(t);
  }, []);

  const slide = heroSlides[current];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background */}
      {heroSlides.map((s, i) => (
        <div
          key={i}
          className="absolute inset-0 transition-opacity duration-1000"
          style={{ opacity: i === current ? 1 : 0 }}
        >
          <img src={s.bg} alt="" className="w-full h-full object-cover object-top" />
        </div>
      ))}

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 flex flex-col items-center text-center">
        {/* Trust badge */}
        <div className="flex items-center gap-3 mb-6 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-5 py-2">
          <div className="flex -space-x-2">
            {[
              'https://readdy.ai/api/search-image?query=young%20black%20man%20avatar%20portrait%20friendly%20casual%20neutral%20background&width=36&height=36&seq=av1&orientation=squarish',
              'https://readdy.ai/api/search-image?query=young%20indian%20woman%20avatar%20portrait%20friendly%20casual%20neutral%20background&width=36&height=36&seq=av2&orientation=squarish',
              'https://readdy.ai/api/search-image?query=young%20caribbean%20man%20avatar%20portrait%20friendly%20casual%20neutral%20background&width=36&height=36&seq=av3&orientation=squarish',
            ].map((src, i) => (
              <img key={i} src={src} alt="" className="w-7 h-7 rounded-full border-2 border-white object-cover" />
            ))}
          </div>
          <span className="text-white text-sm font-medium">{slide.tag}</span>
        </div>

        {/* Title */}
        <h1 className="text-white font-black leading-none mb-2" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(64px, 10vw, 128px)' }}>
          {slide.title}
        </h1>
        <h2 className="text-[#FF6B35] font-thin leading-none mb-8" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(48px, 7vw, 96px)', letterSpacing: '0.05em' }}>
          {slide.subtitle}
        </h2>

        {/* Subtitle */}
        <p className="text-white/80 text-lg max-w-lg mb-10 font-light leading-relaxed">
          Order beer, wine, spirits & more — delivered ice-cold to your door anywhere in Georgetown, Guyana.
        </p>

        {/* CTAs */}
        <div className="flex flex-wrap gap-4 justify-center">
          <Link
            to="/menu"
            className="bg-[#FF6B35] text-white font-bold px-8 py-4 rounded-full flex items-center gap-3 hover:bg-[#e85d2a] transition-all hover:scale-105 cursor-pointer whitespace-nowrap text-base"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shopping-cart-2-fill" />
            </div>
            Order Now
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-up-line" />
            </div>
          </Link>
          <Link
            to="/tracking"
            className="bg-white/15 backdrop-blur-sm border border-white/30 text-white font-semibold px-8 py-4 rounded-full flex items-center gap-2 hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap text-base"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-map-pin-2-line" />
            </div>
            Track Order
          </Link>
        </div>

        {/* Stats row */}
        <div className="mt-16 flex flex-wrap justify-center gap-8">
          {[
            { icon: 'ri-time-line', value: '28 min', label: 'Avg. Delivery' },
            { icon: 'ri-store-2-line', value: '80+', label: 'Partner Stores' },
            { icon: 'ri-user-heart-line', value: '15K+', label: 'Happy Customers' },
            { icon: 'ri-map-pin-line', value: 'Georgetown', label: 'We Deliver Here' },
          ].map((stat) => (
            <div key={stat.label} className="flex flex-col items-center text-center">
              <div className="w-10 h-10 flex items-center justify-center text-[#FF6B35] bg-white/10 rounded-full mb-2">
                <i className={`${stat.icon} text-xl`} />
              </div>
              <span className="text-white font-bold text-lg">{stat.value}</span>
              <span className="text-white/60 text-xs">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Slide dots */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {heroSlides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`h-2 rounded-full transition-all cursor-pointer ${i === current ? 'w-8 bg-[#FF6B35]' : 'w-2 bg-white/50'}`}
          />
        ))}
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 right-8 z-10 flex flex-col items-center gap-2">
        <span className="text-white/50 text-xs rotate-90 tracking-widest">SCROLL</span>
        <div className="w-px h-12 bg-gradient-to-b from-white/50 to-transparent" />
      </div>
    </section>
  );
}
